// Demo satıcı ilanlarının sahibi tek bir "Demo Araç/Emlak" kullanıcısı olduğu
// için, YALNIZCA demo ilanlarda sahibi/katılımcı adını ilan numarasından
// türetilen sabit (deterministik) bir Türkçe ad/soyad ile gösteririz. Gerçek
// kullanıcılarda gerçek ad/soyad gösterilir. Aynı demo ilan her yerde (ilan
// detayı, sohbet listesi, mesajlaşma başlığı) aynı ismi gösterir.

const SELLER_FIRST_NAMES = [
  "Mehmet", "Ahmet", "Mustafa", "Emre", "Burak", "Kerem", "Onur", "Serkan",
  "Volkan", "Cem", "Hakan", "Tolga", "Barış", "Gökhan", "Murat", "Deniz",
];
const SELLER_LAST_NAMES = [
  "Yılmaz", "Demir", "Şahin", "Çelik", "Aydın", "Kaya", "Arslan", "Doğan",
  "Kılıç", "Koç", "Yıldız", "Aksoy", "Polat", "Öztürk", "Korkmaz", "Şimşek",
];

export function sellerDisplayName(seed) {
  const n = Math.abs(Number(seed) || 0);
  const first = SELLER_FIRST_NAMES[n % SELLER_FIRST_NAMES.length];
  const last =
    SELLER_LAST_NAMES[
      Math.floor(n / SELLER_FIRST_NAMES.length) % SELLER_LAST_NAMES.length
    ];
  return `${first} ${last}`;
}

export function isDemoUser(user) {
  return !!(
    user &&
    (user.name === "Demo" ||
      /^demo-[\w-]+@local\.test$/i.test(user.email || ""))
  );
}

export function resolveOwnerName(user, advertNo) {
  const realName = user
    ? `${user.name || ""} ${user.surname || ""}`.trim()
    : "";

  if (isDemoUser(user) || !realName) return sellerDisplayName(advertNo);

  return realName;
}
